import React, { useState, useEffect } from 'react'
import config from 'config'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'

export default function Loader({ title, closeModal, className }) {
  const { t } = useTranslation()
  const [index, setIndex] = useState(0)
  const [quote, setQuote] = useState('')
  const [quotes, setQuotes] = useState(t('loading.quotes', { returnObjects: true }))

  useEffect(() => {
    const tick = () =>
      setIndex((i) => {
        if (i === quotes.length - 1) return 0
        return i + 1
      })
    const id = setInterval(tick, 2000)
    return () => clearInterval(id)
  }, [])

  useEffect(() => {
    setQuote(quotes[index])
  }, [index])

  return (
    <div className={`${styles.loadingContainer} ${className}`}>
      <h1 className={styles.title}>{title || t('group.index.loading')}</h1>
      <img className={styles.image} src={`${config.assetUrl}/images/loaderFinal.gif`} alt='loading' />
      <p className={styles.caroussel}>{quote} </p>
    </div>
  )
}
